// Upload links are stored in two shapes across the app:
//   { data: 'https://…', fileData: {…} }   (upload API response)
//   'https://…'                            (chat attachments, older posts)
// Return the URL string for either, or '' when there is none.
export const resolveLink = link => {
  if (!link) return ''
  if (typeof link === 'string') return normalizeUrl(link)
  if (typeof link === 'object' && typeof link.data === 'string') return normalizeUrl(link.data)
  return ''
}

// The upload API returns locations without a scheme, e.g.
// "sgp1.digitaloceanspaces.com/blossomsociety/file.mp4". Browsers treat that
// as a path on our own site (404), so add https:// to bare host URLs.
export function normalizeUrl(url) {
  if (typeof url !== 'string') return ''
  const u = url.trim()
  if (!u) return ''
  if (/^(https?:|data:|blob:)/i.test(u) || u.startsWith('/') || u.startsWith('#')) return u
  if (u.startsWith('//')) return `https:${u}`
  // looks like "host.tld/…" (has a dot in the first path segment)
  if (/^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?(\/|$)/i.test(u)) return `https://${u}`
  return u
}

// Best URL for a document post, whatever page it came from
export const documentUrl = item =>
  normalizeUrl(item?.document) || resolveLink(item?.Data?.DocumentLink)

// Best URL for an image post (Updates / Timeline)
export const imageUrl = item =>
  resolveLink(item?.Data?.ImageLink) || normalizeUrl(item?.image)

const VIDEO_EXT = /\.(mp4|m4v|webm|mov|ogv|ogg)(\?|#|$)/i

// Media for a timeline post. Videos share the ImageLink field; they are
// recognised by Data.MediaType, the upload's mimetype, or the URL extension.
export const mediaInfo = item => {
  const url = imageUrl(item)
  const link = item?.Data?.ImageLink
  const mime = link && typeof link === 'object' ? link.fileData?.type || '' : ''
  const isVideo =
    item?.Data?.MediaType === 'video' || mime.startsWith('video/') || VIDEO_EXT.test(url)
  return { url, isVideo }
}
